module.exports = __webpack_public_path__ + "static/media/satellite.e750235b.svg";